// extracted by mini-css-extract-plugin
export default {"emptyRosterDay":"EmptyRosterDay_emptyRosterDay__4lGRw","tooltip":"EmptyRosterDay_tooltip__1VBTJ"};